var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66669C11.4485 6.66669 4.00049 12.0377 0 20.0002C4.00049 27.9641 11.4485 33.3337 20 33.3337C28.5515 33.3337 35.9995 27.9641 40 20.0002C35.9995 12.0377 28.5515 6.66669 20 6.66669ZM20 28.3337C15.397 28.3337 11.6665 24.6032 11.6665 20.0002C11.6665 15.3972 15.397 11.6667 20 11.6667C24.603 11.6667 28.3335 15.3972 28.3335 20.0002C28.3335 24.6032 24.603 28.3337 20 28.3337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0002C22.7614 25.0002 25 22.7616 25 20.0002C25 17.2388 22.7614 15.0002 20 15.0002C17.2386 15.0002 15 17.2388 15 20.0002C15 22.7616 17.2386 25.0002 20 25.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile3);
export default __webpack_public_path__ + "static/media/icon-profile_3.ee543ab76ce3afd4c1de08829bdbebb0.svg";
export { ForwardRef as ReactComponent };